import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Image as ImageIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-28 pb-16 lg:pt-36 lg:pb-24 overflow-hidden w-full bg-background" data-id="element-64">
      <div className="max-w-7xl mx-auto px-6" data-id="element-65">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-66">
          {/* Left Column: Text Content & Mobile Image */}
          <div className="flex flex-col" data-id="element-67">
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            ease: 'easeOut'
          }} className="text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-primary leading-[1.15]" data-id="element-68">
              Бухгалтерія для ФОП <br data-id="element-69" />
              <span className="text-secondary" data-id="element-70">
                швидко, надійно, без стресу.
              </span>
            </motion.h1>

            {/* Mobile Image (Visible only on small screens, between Headline and Description) */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 1,
            ease: 'easeOut',
            delay: 0.2
          }} className="block lg:hidden w-full max-w-sm mx-auto h-[350px] rounded-[2rem] overflow-hidden shadow-xl my-7 bg-surface border border-border flex items-center justify-center" data-id="element-71">
              <ImageIcon size={64} className="text-secondary opacity-50" data-id="element-72" />
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            ease: 'easeOut',
            delay: 0.3
          }} className="mt-7 lg:mt-8" data-id="element-73">
              <div className="flex flex-col sm:flex-row items-center gap-4" data-id="element-74">
                <a href="#contact" className="w-full sm:w-auto px-8 py-3.5 bg-primary text-background rounded-full font-medium flex items-center justify-center gap-2 hover:opacity-90 transition-opacity shadow-lg" data-id="element-75">
                  Безкоштовна консультація
                </a>
                <a href="#services" className="w-full sm:w-auto px-8 py-3.5 bg-surface text-primary rounded-full font-medium hover:bg-border/50 transition-colors border border-border flex items-center justify-center" data-id="element-76">
                  Мої послуги
                </a>
              </div>
            </motion.div>
          </div>

          {/* Right Column: Desktop Image (Visible only on large screens) */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          x: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          x: 0
        }} transition={{
          duration: 1,
          ease: 'easeOut',
          delay: 0.2
        }} className="hidden lg:flex justify-end w-full" data-id="element-77">
            <div className="w-full max-w-md h-[500px] rounded-[2.5rem] overflow-hidden shadow-2xl relative bg-surface border border-border flex items-center justify-center group" data-id="element-78">
              <ImageIcon size={80} className="text-secondary opacity-50 group-hover:scale-110 transition-transform duration-1000" data-id="element-79" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}